import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React, { Children } from 'react'

import type { BoxProps } from '@mui/material/Box'

type ChartLegendDatum = {
  color: string
  label: string
  value: number
}

type ChartLegendProps = BoxProps & {
  data?: ChartLegendDatum[]
  showZeroValueLegend?: boolean
}

const ChartLegend = ({ data = [], showZeroValueLegend = true, ...rest }: ChartLegendProps) => (
  <Box alignItems="center" columnGap={2} display="flex" flexWrap="wrap" justifyContent="center" {...rest}>
    {Children.toArray(
      data.map(
        ({ color, label, value }) =>
          (showZeroValueLegend || value > 0) && (
            <Box alignItems="center" display="flex">
              <Box bgcolor={color} height={15} width={15} />
              <Typography ml={0.5}>{label}</Typography>
            </Box>
          )
      )
    )}
  </Box>
)

export default ChartLegend
